function escapeVCard(value) {
  return String(value || '').replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
}

function foldVCardLine(line) {
  const encoder = new TextEncoder();
  const parts = [];
  let current = '';
  let width = 0;
  for (const character of line) {
    const bytes = encoder.encode(character).length;
    if (width + bytes > 75) {
      parts.push(current);
      current = ' ';
      width = 1;
    }
    current += character;
    width += bytes;
  }
  parts.push(current);
  return parts.join('\r\n');
}

export function vCardFor(member) {
  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${escapeVCard(member.lastName)};${escapeVCard(member.firstName)};;;`,
    `FN:${escapeVCard(member.name)}`,
  ];
  if (member.email) lines.push(`EMAIL;TYPE=INTERNET:${escapeVCard(member.email)}`);
  if (member.phone) lines.push(`TEL;TYPE=CELL:${escapeVCard(member.phone)}`);
  lines.push('END:VCARD');
  return `${lines.map(foldVCardLine).join('\r\n')}\r\n`;
}

export function vCardFilename(name) {
  const base = String(name || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 64);
  return `${base || 'contact'}.vcf`;
}
